import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import { connect } from 'react-redux'

import {
  getPatientNotes,
  createNewPatientNote,
  updatePatientNote,
  deletePatientNote,
} from '../../../state/actions/selected-patient'
import Note from './Note'
import css from './notes.css'

class Notes extends Component {

  static propTypes = {
    patientId: PropTypes.string.isRequired,
    getNotes: PropTypes.func.isRequired,
    deleteNote: PropTypes.func.isRequired,
    updateNote: PropTypes.func.isRequired,
    createNote: PropTypes.func.isRequired,
    notes: PropTypes.arrayOf(PropTypes.object).isRequired,
  }

  state = {
    isFetching: false,
    isNewNoteOpen: false,
  }

  componentWillMount() {
    this.setState({
      isFetching: true,
    })
    const { getNotes, patientId } = this.props
    getNotes(patientId)
    .then(() => {
      this.setState({
        isFetching: false,
      })
    })
  }

  onCreate = (newNote) => {
    const { createNote, patientId } = this.props
    this.setState({
      isLoading: true,
    })
    return createNote(patientId, { body: newNote })
    .then(() => {
      this.setState({
        isNewNoteOpen: false,
        isLoading: false,
      })
      return Promise.resolve()
    })
  }

  onUpdate = (updatedBody, noteId, index) => {
    const { updateNote, patientId } = this.props
    this.setState({
      isLoading: true,
    })
    return updateNote(patientId, noteId, { body: updatedBody }, index)
    .then(() => {
      this.setState({
        isLoading: false,
      })
      return Promise.resolve()
    })
  }

  onDelete = (noteId, index) => {
    const { deleteNote, patientId } = this.props
    this.setState({
      isLoading: true,
    })
    deleteNote(patientId, noteId, index)
    .then(() => {
      this.setState({
        isLoading: false,
      })
    })
  }

  onCancel = () => {
    this.setState({
      isNewNoteOpen: false,
    })
  }

  addNote = () => {
    this.setState({
      isNewNoteOpen: true,
    }, () => {
      const lastNoteIndex = this.notes.childNodes.length - 1
      this.notes.childNodes[lastNoteIndex].scrollIntoView(true)
    })
  }

  renderNotes = () => (this.props.notes.map((note, index) => (
    <Note
      key={note.id}
      note={note}
      onSave={this.onUpdate}
      onDelete={this.onDelete}
      onCancel={this.onCancel}
      index={index}
    />
  )))

  render() {
    return (
      <div className={css.container}>
        <div
          className={css.notesList}
          ref={(notes) => { this.notes = notes }}
        >
          {this.props.notes.length > 0
            ? this.renderNotes()
            : 'No notes added yet'
          }
          {
            this.state.isNewNoteOpen &&
            <Note
              note={{ id: 0, body: '' }}
              onSave={this.onCreate}
              onCancel={this.onCancel}
            />
          }
        </div>
        {
          !this.state.isNewNoteOpen &&
          <FloatingActionButton
            backgroundColor="#6040B0"
            className={css.addButton}
            onClick={this.addNote}
          >
            <ContentAdd />
          </FloatingActionButton>
        }
      </div>
    )
  }
}

const mapStateToProps = ({ selectedPatient }) => ({
  patientId: selectedPatient.id,
  notes: selectedPatient.notes,
})

const mapDispatchToProps = dispatch => ({
  getNotes: patientId => dispatch(getPatientNotes(patientId)),
  createNote: (patientId, body) => dispatch(createNewPatientNote(patientId, body)),
  updateNote: (patientId, noteId, body, index) => dispatch(updatePatientNote(patientId, noteId, body, index)),
  deleteNote: (patientId, noteId, index) => dispatch(deletePatientNote(patientId, noteId, index)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notes)



// WEBPACK FOOTER //
// ./src/components/PatientPage/Notes/index.js